/**
 * Methods of adding or removing cart items
 */
export enum GtagCartUpdateMethod {
    /**
     * 'All Products' catalog
     */
    ALL_PRODUCTS_CATALOG = 'ALL_PRODUCTS_CATALOG',

    /**
     * Donation tool on the cart page
     */
    CART_PAGE_DONATION_TOOL = 'CART_PAGE_DONATION_TOOL',

    /**
     * Item already in cart quantity changed from the cart page
     */
    CART_PAGE_QUANTITY_CHANGE_TOOL = 'CART_PAGE_QUANTITY_CHANGE_TOOL',

    /**
     * A multi-add-to-cart block
     *
     * > **NOTE:** This is specifically referring to the **block** and not every
     * > pop-up modal which uses the multi-add-to-cart interface.
     */
    MULTI_ADD_TO_CART_BLOCK = 'MULTI_ADD_TO_CART_BLOCK',

    /**
     * Main details page for the product
     */
    PRODUCT_DETAILS_PAGE = 'PRODUCT_DETAILS_PAGE',

    /**
     * The quick shop tool
     */
    QUICK_SHOP_TOOL = 'QUICK_SHOP_TOOL',

    /**
     * The product circle block
     */
    PRODUCT_CIRCLE_BLOCK = 'PRODUCT_CIRCLE_BLOCK',

    /**
     * The field transfer calculator
     */
    FIELD_TRANSFER_CALCULATOR = 'FIELD_TRANSFER_CALCULATOR',

    /**
     * PWS home page products
     */
    PWS_HOME_PAGE_PRODUCTS_BLOCK = 'PWS_HOME_PAGE_PRODUCTS_BLOCK',

    /**
     * Added from the conference system
     */
    CONFERENCE = 'CONFERENCE',
}
